module.exports = __webpack_public_path__ + "static/media/ServicesNPDIcon.d10cdd75.svg";